import { render, staticRenderFns } from "./ThirdPartyLoginV3.vue?vue&type=template&id=7af83342&scoped=true&"
import script from "./ThirdPartyLoginV3.vue?vue&type=script&lang=js&"
export * from "./ThirdPartyLoginV3.vue?vue&type=script&lang=js&"
import style0 from "./ThirdPartyLoginV3.vue?vue&type=style&index=0&id=7af83342&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7af83342",
  null
  
)

export default component.exports